// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2mASu","col":"styles_col__1dF-o"};